import React, { useContext, useState, useEffect } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { HiFilter, HiOutlineFilter } from 'react-icons/hi';
import { TicketContext } from '../../../app/providers/TicketContext';

const LeftPanelTopBar = ({ 
  onSearch, 
  searchTerm = '', 
  selectedMainflows = [], 
  onSearchTermChange,
  onMainflowsChange 
}) => {
  const { setFilterStatus, tickets } = useContext(TicketContext);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  
  // Benzersiz MAINFLOW değerlerini al
  const uniqueMainflows = [...new Set(tickets.map(ticket => ticket.MAINFLOW).filter(Boolean))];

  // Arama ve MAINFLOW filtresini birleştir
  const handleSearch = (value) => {
    if (onSearchTermChange) {
      onSearchTermChange(value);
    }
    applyFilters(value, selectedMainflows);
  };

  // MAINFLOW filtresini uygula
  const handleMainflowFilter = (mainflow) => {
    const isSelected = selectedMainflows.includes(mainflow);
    const newMainflows = isSelected
      ? selectedMainflows.filter(flow => flow !== mainflow)
      : [...selectedMainflows, mainflow];
    
    if (onMainflowsChange) {
      onMainflowsChange(newMainflows);
    }
    applyFilters(searchTerm, newMainflows);
  };

  // Tüm filtreleri temizle
  const clearAllFilters = () => {
    if (onMainflowsChange) {
      onMainflowsChange([]);
    }
    applyFilters(searchTerm, []);
  };

  // Tüm filtreleri uygula
  const applyFilters = (search, mainflows) => {
    if (onSearch) {
      onSearch((ticket) => {
        if (!ticket) return false;

        // Arama terimi kontrolü — TICID, UNAME, USEREXP, MAINFLOW alanlarında ara
        const q = (search || '').trim().toLowerCase();
        const searchMatch = !q ||
          (ticket.TICID !== undefined && ticket.TICID !== null && String(ticket.TICID).toLowerCase().includes(q)) ||
          (ticket.UNAME && String(ticket.UNAME).toLowerCase().includes(q)) ||
          (ticket.USEREXP && String(ticket.USEREXP).toLowerCase().includes(q)) ||
          (ticket.MAINFLOW && String(ticket.MAINFLOW).toLowerCase().includes(q));

        // MAINFLOW filtresi kontrolü - seçili filtre yoksa veya ticket'ın MAINFLOW'u seçili filtreler içindeyse
        const mainflowMatch = mainflows.length === 0 || mainflows.includes(ticket.MAINFLOW);

        return searchMatch && mainflowMatch;
      });
    }
  };

  // Filtreleri uygula
  useEffect(() => {
    applyFilters(searchTerm, selectedMainflows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMainflows, searchTerm]);

  return (
    <div className="#323F53 bg-[#323F53] shadow-sm border-b border-slate-600/60 p-2.5 space-y-2.5">
      <div className="flex items-center justify-between">
        <h2 className="text-white text-[12px] font-semibold tracking-wide">Flows</h2>
      </div>

      <div className="flex gap-1.5">
        <div className="relative flex-1">
          <IoSearchOutline className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
          <input
            type="text"
            value={searchTerm}
            placeholder="Search..."
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full py-1.5 pl-7 pr-2 rounded-md bg-slate-600 text-white placeholder-slate-300 focusing:outline-none focus:ring-1 focus:ring-blue-400 text-[11px]"
          />
        </div>
        
        <div className="relative">
          <button
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            className={`h-8 w-8 flex items-center justify-center rounded-md border border-slate-500/70 transition-colors ${
              selectedMainflows.length > 0 ? 'bg-blue-500' : 'bg-gray-600'
            } hover:bg-opacity-80`}
          >
            {selectedMainflows.length > 0 ? (
              <div className="relative">
                <HiFilter className="text-white text-sm" />
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] rounded-full w-3 h-3 flex items-center justify-center">
                  {selectedMainflows.length}
                </span>
              </div>
            ) : (
              <HiOutlineFilter className="text-white text-sm" />
            )}
          </button>

          {/* MAINFLOW Filtre Menüsü */}
          {isFilterOpen && (
            <div className="absolute right-0 mt-1 w-44 bg-slate-800/95 rounded-md shadow-lg border border-slate-600/70 z-50 py-1">
              <button
                onClick={clearAllFilters}
                className="w-full px-3 py-1.5 text-left text-white/90 hover:bg-slate-700 text-[11px]"
              >
                Clear All
              </button>
              <div className="border-t border-gray-700 my-1"></div>
              {uniqueMainflows.map((mainflow, index) => (
                <button
                  key={index}
                  onClick={() => handleMainflowFilter(mainflow)}
                  className={`w-full px-3 py-1.5 text-left hover:bg-slate-700 flex items-center justify-between text-[11px] ${
                    selectedMainflows.includes(mainflow) ? 'bg-blue-500 text-white' : 'text-white'
                  }`}
                >
                  <span className="truncate">{mainflow}</span>
                  {selectedMainflows.includes(mainflow) && (
                    <span className="text-[10px] bg-blue-600 px-1.5 py-0.5 rounded-full ml-1">✓</span>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Seçili filtreler */}
      {selectedMainflows.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {selectedMainflows.map((flow, index) => (
            <span
              key={index}
              className="bg-blue-500 text-white text-[10.5px] px-2 py-0.5 rounded-full flex items-center"
            >
              <span className="truncate max-w-[72px]">{flow}</span>
              <button
                onClick={() => handleMainflowFilter(flow)}
                className="ml-1 hover:text-red-200 text-[10px]"
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    
    </div>
  );
};

export default LeftPanelTopBar;